export default __webpack_public_path__ + "static/media/thumbnail.682e685a.png";